import React from 'react'
import { NavLink } from 'react-router-dom'
import TeamCard from '../components/TeamCard'
const Developer = () => {

    return (
        <>
        <div classNameName="maincontent">
        <div className="typewriter-text2 text-center p-md-0"><h1 className="">NSS DEVELOPER'S TEAM</h1></div>
            <div className="button">
            <div className="mt-2 mb-5">
          <ul class="nav nav-underline justify-content-center">
            <li class="nav-item">
            <NavLink class="nav-link" to="/team" style={{ textDecoration: 'none'}}>
                <button className='btn btn-light px-4 text-dark'>Core Team</button>
              </NavLink>
            </li>
            <li class="nav-item">
              <NavLink class="nav-link" to="/developer" style={{ textDecoration: 'none' ,color:'black'}}>
              <button className='btn btn-primary px-2'>Developers</button>
              </NavLink>
            </li>
          </ul>
        </div>
            </div>
            <p
          style={{ textAlign: "center", fontSize: "1.5rem", fontWeight: "600" }}
        >
          {" "}
          Developer's Team
        </p>
            <hr width="100%"/>
            
    
            <div className="card_team-wrapper2">
                <TeamCard name="Rohit Pimple" position="Technical Head" imageLink="https://i.postimg.cc/SxLTztn4/IMG-20240417-200218.jpg" gmail="rohitpimple623@gmail.com" linkedin="https://www.linkedin.com/in/rohitpimple/" github="https://github.com/rohitpimple"/>

                <TeamCard name="Pranav Bhiungade" position="Frontend Head" imageLink="https://i.postimg.cc/BbNcW4Kw/pranav-Crop.jpg" gmail="pranavbhiungade25@gmail.com" linkedin="https://www.linkedin.com/in/pranav-bhiungade-4369741b1?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app" github="https://github.com/pranavzz"/>
    
                <TeamCard name="Adarsh Jain" position="Backend Head" imageLink="https://i.postimg.cc/QMqnG8WL/Adarsh-Jain.jpg" gmail="adarshjain0508@gmail.com" linkedin="https://www.linkedin.com/in/adarsh-jain-37aaa622a" github="https://www.github.com/ajain0508"/>

                <TeamCard name="Parth Sali" position="Design Head" imageLink="https://i.postimg.cc/pTRbzcKv/Parth-Sali.jpg" gmail="parthsali04@gmail.com" linkedin="https://www.linkedin.com/in/parthsali/" github="https://github.com/parthsali"/>
    
            </div>
            <div className="card_team-wrapper2">
                <TeamCard name="Vishal Bhokre" position="Activity Head" imageLink="https://i.postimg.cc/nrhVMWVW/Whats-App-Image-2024-07-17-at-23-40-07-3a6ea6bf.jpg" gmail="vishalbhokre99@gmail.com" linkedin="https://www.linkedin.com/in/vishal-bhokre-9604211b7?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app" github="https://github.com/itsvishal07"/>

                <TeamCard name="Pranav Dangare" position="Activity Head" imageLink="https://i.postimg.cc/904G214s/IMG-20240210-112438170-HDR-AE-2.jpg" gmail="pranavdangare13@gmail.com" linkedin="https://www.linkedin.com/in/pranav-dangare-a040b3230/" github="https://www.github.com"/>

                <TeamCard name="Ajit Kale" position="Design Head" imageLink="https://i.postimg.cc/dVhhDD4c/ajit7.jpg" gmail="ajitkale2406@gmail.com" linkedin="https://www.linkedin.com/in/ajit-kale-4a759625a?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app" github="https://www.github.com"/>

                <TeamCard name="Rushikesh Gaikwad" position="Volunteer" imageLink="https://i.postimg.cc/jq62FdH6/IMG-20240408-WA0021-Rushikesh.jpg" gmail="rushigaikwad7898@gmail.com" linkedin="https://www.linkedin.com/in/rushikesh-gaikwad-74614b293/" github="https://github.com/RushikeshGaikwad78"/>
    
            </div>
            <div className="card_team-wrapper2">
                <TeamCard name="Hitesh Pawar" position="Volunteer" imageLink="https://i.postimg.cc/8C8VGLD7/IMG-20240328-003825-Hitesh-Pawar.jpg" gmail="hiteshpawar2804@gmail.com" linkedin="https://www.linkedin.com/in/hiteshpawar2804" github="https://github.com/hiteshp28"/>

                <TeamCard name="Yash Savale" position="Volunteer" imageLink="https://i.postimg.cc/cHy1FV65/Sonawane-Class-photo-Yash-Savale.jpg" gmail="savaleyash004@gmail.com" linkedin="https://www.linkedin.com/in/yash-savale-3b5876269?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app" github="https://github.com/savaleyash004"/>

                <TeamCard name="Onkar Patil" position="Volunteer" imageLink="https://i.postimg.cc/hP5zq4jX/IMG-20240224-213732-093830-Onkar-Patil.jpg" gmail="onkardpatil07@gmail.com" linkedin="https://www.linkedin.com/in/onkar-patil-9289a0257?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app" github="https://www.github.com"/>
    
                <TeamCard name="Sahil Amrutkar " position="Volunteer" imageLink="https://i.postimg.cc/L8Gmsrk6/IMG-20240403-230649-SAHIL-AMRUTKAR.jpg" gmail="sahilamrutkar1808@gmail.com" linkedin="https://www.linkedin.com/in/sahil-amrutkar-a43a98263?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app" github="https://github.com/Sahil252004"/>
    
                
            </div>

            <div className="card_team-wrapper2">
                <TeamCard name="Divya Jain" position="Volunteer" imageLink="https://i.postimg.cc/gkYjFFsC/IMG-20240318-WA0013-Divya-Jain.jpg" gmail="divyaj0127@gmail.com" linkedin="https://www.linkedin.com/" github="https://www.github.com/divyaj2701"/>

                <TeamCard name="Vaishnavi Wadkar" position="Volunteer" imageLink="https://i.postimg.cc/NM6sSpHG/IMG-1176-Vaishnavi-Wadkar.jpg" gmail="vaishnaviwadkar11@gmail.com" linkedin="https://www.linkedin.com/in/vaishnavi-wadkar-37a34325b?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app" github="https://github.com/savaleyash004"/>

                <TeamCard name="Lavanya mahalle" position="Volunteer" imageLink="https://i.postimg.cc/6QG5L96v/IMG-20240415-WA0017-Lavany-Mahalle.jpg" gmail="mahallelavanya@gmail.com" linkedin="https://www.linkedin.com/" github="https://www.github.com/lavanyamahalle13"/>
    
                <TeamCard name="Rutuja Gangawane" position="Volunteer" imageLink="https://i.postimg.cc/nhWhDsxx/Whats-App-Image-2024-01-16-at-15-33-22-c9f9f23a-Rutuja-Gangawane.jpg" gmail="rutujagangawane21@gmail.com" linkedin="https://www.linkedin.com/" github="https://github.com/rutujagangawane"/>
    
                </div>

            <div className="card_team-wrapper2">
    
                <TeamCard name="Rohit Patil" position="Volunteer" imageLink="https://i.postimg.cc/BvD4PMN5/rohit-Rohit-Patil.avif" gmail="rohitpatil8226@gmail.com" linkedin="https://www.linkedin.com/" github="https://www.github.com/rohitpatil33"/>
            </div>
          </div>
        </>
      )
}

export default Developer
